<template>
  <div class="animated fadeIn">
  
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="getData"
          :total-data="totalRows"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="spkbForm"
          :redirect-detail="true"
          :custom-variable-id="'spkb_number'"
          :show-add-button="false"
          :search-by-delivery-date="true"
          caption="<i class='fa fa-align-justify'></i> Daftar Piutang"
          @adjustmentActualSpkb="adjustmentActualSpkb"
        ></global-table>

       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";
import globalTable from "../../templates/TableNew.vue";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";

export default {
  name: "finance-piutang",
  components: {
    globalTable,
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      spkb: [],
      loading: true,
      spkbForm: interfaces.spkb,
      fields: [
        { key: "spkb_number", sortable: true },
        { key: "driver_name", label: "Nama Supir" },
        { key: "penanggung_jawab_faktur", label: "Penanggung Jawab Faktur" },
        { key: "total_price_plan", label: "Total Plan" },
        { key: "total_price_actual", label: "Total Aktual" },
        { key: "total_price_retur", label: "Total Retur" },
        { key: "delivery_date", label: "Tanggal Pengiriman" },
        { key: "action_piutang", label: "Action", class: "text-center width-150" }
      ],
      show_dc: false,
      totalRows: "",
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    getData: function(ctx) {
      this.loading = true;
      let response = axios.post('web/product/cost-return-product', ctx);
      return response.then((data) => {
        const items = data.data.data;
        this.totalRows = data.data.total_rows;
        this.loading=false;
        return(items)
      }).catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },
    editForm: function(a) {
      this.resetForm();
      this.spkbForm = a;
    },
    adjustmentActualSpkb: function(item) {
      console.log(item)
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
   // this.init();
  }
};
</script>

<style>
</style>